import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "..";

type State = {
  isLoading: boolean;
  videoAsk: {
    url?: string;
    showAction: boolean;
    expandOnLoad: boolean;
  };
  hideCookieConsent?: boolean;
};

const initialState: State = {
  isLoading: false,
  videoAsk: {
    url: undefined,
    showAction: true,
    expandOnLoad: true,
  },
  hideCookieConsent: true,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setVideoAskUrl: (state, action) => {
      state.videoAsk.url = action.payload;
    },
    setVideoAskShowAction: (state, action) => {
      state.videoAsk.showAction = action.payload;
    },
    setVideoAskExpandOnLoad: (state, action) => {
      state.videoAsk.expandOnLoad = action.payload;
    },
    setHideCookieConsent: (state, action) => {
      state.hideCookieConsent = action.payload;
    },
  },
});

export const {
  setLoading,
  setVideoAskUrl,
  setVideoAskShowAction,
  setVideoAskExpandOnLoad,
  setHideCookieConsent,
} = uiSlice.actions;

export default uiSlice.reducer;

export const selectLoading = (state: RootState) => state.ui.isLoading;

export const selectVideoAsk = (state: RootState) => state.ui.videoAsk;

export const selectHideCookieConsent = (state: RootState) =>
  state.ui.hideCookieConsent;
